/* global Pace */
const Pace = require('pace-js');
const ProgressivLoading = require('./progressivLoading');
const FlickitySlider = require("./flickity-slider");
const HASH = window.location.hash;
window.location.hash = '';

(function($){
    "use strict";

    let $document = $(document),
        $window = $(window),
        $htmlBody = $('html, body'),
        $body = $('body'),
        $navbar = $('#navigation'),
        $pageScrollLink = $('.page-scroll'),
        $scrollToTop = $('.scroll-to-top'),
        navHeight = 60,
        navHeightMob = 40,
        loader = $('#loader-general');
    loader.hide();

    let ww = Math.max($window.width(), window.innerWidth);

    /** Detect mobile device */
    let isMobile = {
        Android: function(){
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function(){
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function(){
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function(){
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function(){
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function(){
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };

    let initCar = $('.component-carousel').not('.loadThis');
    if (initCar.length > 0) {
        initCar.each(function () {
            let el = this.id;
            FlickitySlider.init('#' + el + ' .main-carousel', el === 'offres' ? 7000 : false);
        });
    }

    /*
    * Window load
    */

    $window.on('load', function(){
        ProgressivLoading.bind();
    });


    /*
    * Document ready
    */

    $document.ready(function(){

        /*
        * Window scroll
        */

        $window.on('scroll', function(){
            if ($document.scrollTop() > navHeight){

                /** Shrink navigation */
                $navbar.addClass('shrink');

                /** Scroll to top */
                $scrollToTop.fadeIn();
            }
            else{

                /** Shrink navigation */
                $navbar.removeClass('shrink');

                /** Scroll to top */
                $scrollToTop.fadeOut();
            }
        });


        /*
        * Window resize
        */

        $window.resize(function() {
            /** Bootstrap scrollspy */
            let dataScrollSpy = $body.data('bs.scrollspy'),
                ww = Math.max($window.width(), window.innerWidth),
                offset = ww > 767 ? navHeight : navHeightMob;

            dataScrollSpy._config.offset = offset;
            $body.data('bs.scrollspy', dataScrollSpy);
            $body.scrollspy('refresh');
        });

        /** Page scroll */
        $pageScrollLink.click( function(e) {
            if ($pageScrollLink.parents('.sticky-element')) {
                let textStickyBtn = e.currentTarget.dataset.title;
                dataLayer.push({'event':'CTA', 'eventCategory': 'Sticky', 'eventLabel': textStickyBtn, 'eventAction': 'Clic'});
            } else {
                let textBtn = e.currentTarget.dataset.title,
                    orderBtn = e.currentTarget.dataset.order;
                if (textBtn != undefined && orderBtn != undefined) {
                    dataLayer.push({'event':'CTA', 'eventCategory': 'comp0' + orderBtn, 'eventLabel' : textBtn, 'eventAction': 'Clic'});
                }
            }
            let thisFamily = '';
            if (e.currentTarget.dataset.family !== undefined && e.currentTarget.dataset.family !== '') {
                thisFamily = e.currentTarget.dataset.family;
                if (thisFamily[0] === '[') {
                    thisFamily = parseInt(thisFamily.split('[')[1].split(']')[0]);
                }
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            loader.show();

            let toLoad = [], found = false, anchor = $(this).attr('href');

            $('.loadThis').each(function() {
                if(!found) {
                    toLoad.push(this.id);
                }
                if(anchor.replace('#','') === this.id) {
                    found = true;
                }
            });

            ProgressivLoading.loadAll(toLoad).then(() => {
                setTimeout(() => {
                    loader.hide();
                    if (thisFamily !== '') {
                        let event = new CustomEvent('familyChoice', {
                            detail: {
                                family: thisFamily
                            }
                        });
                        document.dispatchEvent(event);
                    }
                    pageScroll(anchor);
                }, 250);
            });
        });

        $('.loadThis').delegate( '.page-scroll', 'click', function(e) {
            let textBtn = e.currentTarget.dataset.title,
                orderBtn = e.currentTarget.dataset.order;
            if (textBtn != undefined && orderBtn != undefined) {
                dataLayer.push({'event':'CTA', 'eventCategory': 'comp0' + orderBtn, 'eventLabel' : textBtn, 'eventAction': 'Clic'});
            }
            let thisFamily = '';
            if (e.currentTarget.dataset.family !== undefined && e.currentTarget.dataset.family !== '') {
                thisFamily = e.currentTarget.dataset.family;
                if (thisFamily[0] === '[') {
                    thisFamily = parseInt(thisFamily.split('[')[1].split(']')[0]);
                }
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            loader.show();

            let toLoad = [], found = false, anchor = $(e.target).attr('href');

            $('.loadThis').each(function() {
                if(!found) {
                    toLoad.push(this.id);
                }
                if(anchor.replace('#','') === this.id) {
                    found = true;
                }
            });

            ProgressivLoading.loadAll(toLoad).then(() => {
                setTimeout(() => {
                    loader.hide();
                    if (thisFamily !== '' && typeof thisFamily === 'number') {
                        const myDelegateEvent = new CustomEvent('familyChoice', {
                            detail: {
                                family: thisFamily
                            }
                        });
                        document.dispatchEvent(myDelegateEvent);
                    }
                    pageScroll(anchor);
                }, 250);
            });
        });

        window.addEventListener('popstate', function (e) {
            const getMyNewHash = e.currentTarget.location.hash === '#mentions' ? '#ml' : e.currentTarget.location.hash;
            window.location.hash = '';
            onHashChange(getMyNewHash);
        });

        if (HASH.length > 0 && HASH.split('#').length > 1) {
            onHashChange(HASH);
        }

        $('.loadThis').delegate( 'sup', 'click', (e) => {
            e.preventDefault();
            loader.show();

            let toLoad = [], found = false, HASH = '#ml';
            $('.loadThis').each(function() {
                if(!found) {
                    toLoad.push(this.id);
                }
                if(HASH.replace('#','') === this.id) {
                    found = true;
                }
            });

            ProgressivLoading.loadAll(toLoad).then((promises) => {
                let $carousels = [];
                for (let i = 0; i < promises.length; i++) {
                    if (document.getElementById(promises[i]).classList.contains('component-carousel')) {
                        let $carousel = $('#' + promises[i] + ' .main-carousel');
                        $carousels.push($carousel);
                    }
                }
                let myPromises = [];
                for (let i = 0; i < $carousels.length; i++) {
                    if (!$carousels[i].hasClass('flickity-enabled')) {
                        myPromises.push(
                            new Promise((resolve, reject) => {
                                $carousels[i].on('ready.flickity', function() {
                                    $carousels[i].on('lazyLoad.flickity', (event, cellElement) => resolve(event));
                                });
                            }, () => {
                                reject();
                            })
                        );
                    }
                }

                Promise.all(myPromises).then(() => {
                    setTimeout(() => {
                        loader.hide();
                        pageScroll(HASH);
                    }, 1000);
                });
            });
        });

        function pageScroll(target) {
            let ww = Math.max($window.width(), window.innerWidth),
                offset = ww > 767 ? navHeight : navHeightMob;

            if (target) {
                $htmlBody.stop().animate({
                    scrollTop: $(target).offset().top - (offset - 1)
                }, 1000, 'easeInOutExpo');
            }
        }

        function onHashChange(getMyHash) {
            let HASH = getMyHash;
            loader.show();
            // Si le hash est pas vide on charge au moins les 3 premieres sections
            let toLoad = [], found = false;
            $('.loadThis').each(function() {
                if(!found) {
                    toLoad.push(this.id);
                }
                if(HASH.replace('#','') === this.id) {
                    found = true;
                }
            });
            ProgressivLoading.loadAll(toLoad).then((promises) => {
                let $carousels = [];
                for (let i = 0; i < promises.length; i++) {
                    if (document.getElementById(promises[i]).classList.contains('component-carousel')) {
                        let $carousel = $('#' + promises[i] + ' .main-carousel');
                        $carousels.push($carousel);
                    }
                }
                let myPromises = [];
                for (let i = 0; i < $carousels.length; i++) {
                    if (!$carousels[i].hasClass('flickity-enabled')) {
                        myPromises.push(
                            new Promise((resolve, reject) => {
                                $carousels[i].on('ready.flickity', function() {
                                    $carousels[i].on('lazyLoad.flickity', (event, cellElement) => resolve(event));
                                });
                            }, () => {
                                reject();
                            })
                        );
                    }
                }

                Promise.all(myPromises).then(() => {
                    setTimeout(() => {
                        loader.hide();
                        pageScroll(HASH);
                    }, 1000);
                });
            });
        }
    });
})(jQuery);
